import { Box } from '@mui/material';
import { useCompanyPlanContext } from 'FeatureModules/Auth/Contexts/CompanyPlanContext';
import { CardContainer, ItemCardSmall, ThemeButton, ThemeTypography } from 'DesignSystem';
import Image from 'DesignSystem/DataDisplay/Image/Image';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import React, { FC } from 'react';
import { EBackgroundTypes } from 'DesignSystem/types/background.types';
import { EAvailableSizes } from 'DesignSystem/types/size.types';
import { ISite } from 'FeatureModules/Site/types/site.types';
import {
  getSiteSecondTitle,
  getSiteTitle,
  SiteTypeLabels,
} from 'FeatureModules/Site/utils/site.utils';
import FlexBox from 'Components/FlexBox';

interface IPolygonDataCardProps {
  site: ISite;
  onAddPlotClick: () => void;
}

const PolygonDataCard: FC<IPolygonDataCardProps> = ({ site, onAddPlotClick }) => {
  const { company } = useCompanyPlanContext();

  const siteSecondTitle = getSiteSecondTitle({
    site,
    farmDisplayOption: company.farmDisplayOption,
    siteDisplayOption: company.siteDisplayOption,
  });

  return (
    <CardContainer
      size={EAvailableSizes.LARGE}
      background={EBackgroundTypes.MAP_LAYERS}
      title="Upload or draw plots for the cultivation area of each site"
    >
      <Box mt="auto" pb={2}>
        <ItemCardSmall>
          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <Box display="flex" alignItems="center">
              {!!site.image ? (
                <Image width={44} height={44} image={site.image} />
              ) : (
                <Box display="flex" bgcolor="white" borderRadius="6px" padding="4px">
                  <Icon name="site-placeholder" size="xx-large" color="blue-ice" />
                </Box>
              )}
              <Box ml={1.5}>
                <FlexBox>
                  <ThemeTypography variant="ITEM_TITLE">
                    {getSiteTitle({
                      site,
                      farmDisplayOption: company.farmDisplayOption,
                      siteDisplayOption: company.siteDisplayOption,
                    })}
                  </ThemeTypography>
                  {siteSecondTitle && (
                    <Box ml={0.8}>
                      <ThemeTypography
                        variant="BODY_MEDIUM"
                        autoOverflow
                        maxWidth={150}
                        color="GRAY_80"
                      >
                        | {siteSecondTitle}
                      </ThemeTypography>
                    </Box>
                  )}
                </FlexBox>
                <FlexBox>
                  <Icon name="tag-filled" size="small" color="gray-60" />
                  <Box ml={0.5} />
                  <ThemeTypography variant="LABEL_INPUT">
                    {SiteTypeLabels[site.siteType]}
                  </ThemeTypography>
                  <Box ml={1} />
                  <Icon name="location" size="small" color="gray-60" />
                  <Box ml={0.5} />
                  <ThemeTypography variant="LABEL_INPUT">{site.locationName}</ThemeTypography>
                </FlexBox>
              </Box>
            </Box>
            <ThemeButton
              color="PRIMARY"
              size="large"
              startIcon={<Icon name="plus" color="WHITE" />}
              onClick={onAddPlotClick}
            >
              Add plot
            </ThemeButton>
          </Box>
        </ItemCardSmall>
      </Box>
    </CardContainer>
  );
};

export default PolygonDataCard;
